module.exports = __webpack_public_path__ + "img/ic-mobile.4917d48d.svg";